export const domainRegex = new RegExp(
  /^[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,6}$/i,
)
